module.exports = __webpack_public_path__ + "media/images/apps/apple-store-1e72e6d9fba05acd5470571db00a4764.png";